import { render, staticRenderFns } from "./PushList.vue?vue&type=template&id=24ddd5a0&scoped=true"
import script from "./PushList.vue?vue&type=script&lang=js"
export * from "./PushList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ddd5a0",
  null
  
)

export default component.exports